// extracted by mini-css-extract-plugin
module.exports = {"default":"Alert_default__tugfM","error":"Alert_error__2BlfD","info":"Alert_info__sOeFi"};